import Feather from '@sysunite/react-feather'
import { Modal } from 'antd'
import { ContextMenu, showActionsPage, showCreateMacro } from 'Components'
import { Macro } from 'Model'
import * as Types from 'Types'
import WeaverService from 'Services/WeaverService'
import { getNodeLabel, getProjectData } from 'Services/WeaverUtils'
import { getUid } from 'Services/WeaverUtils'
import BaseTreeNode from './BaseTreeNode'
import { store } from '~/Store'
import { createRoot, ComplexLabel, createNewItem, editDeleteCtxMenu, getIcon, getIds } from './shared'
import { deleteMacro } from 'Actions/homeTree'

macrosRootTitle = (
  <ComplexLabel
    title="Form"
    onClick={ -> showCreateMacro() }
    testId="create-macro"
  />
)

getMacros = () ->
  macros = (await Macro.list())
    .filter((macro) ->
      { isHidden } = macro.mapDbConfigToState()
      !isHidden
    )
  sorted = _.sortBy(macros, (macro) -> macro.get('name')?.toLowerCase())
  if macros.length is 0 then [createMacro] else sorted.map(macroTreeNode)

export macrosRoot = createRoot(macrosRootTitle, Types.MACROS, 'all_macros', getMacros, Types.USERMODES.SIMPLE, true)

export createMacro = createNewItem('all_macros', 'macro', Types.CREATE_MACRO)

export macroTreeNode = (macro) ->
  {
    node: macro
    key: macro.id()
    path: "all_macros/#{ macro.id() }"
    type: Types.MACRO
    isLeaf: true
    title: (
      <ContextMenu actions={macroCtxMenu(undefined, macro)}>
        <BaseTreeNode
          testId="macro-#{getNodeLabel(macro)}"
          label={getNodeLabel(macro)}
        />
      </ContextMenu>
    )
    selectable: true
  }

macroCtxMenu = editDeleteCtxMenu(
  'macro',
  (props, node, { domEvent }) ->
    domEvent.stopPropagation()
    showCreateMacro(node.id())
  , (props, node) ->
    store.dispatch(deleteMacro(node.id()))
    await node.destroy()
    await WeaverService.updateMacros()
)

export default {
  [Types.MACRO]: ({ node }) -> showActionsPage(node.get('configBlob'))
  [Types.MACROS]: (node) -> # macros onClick //undefined
  [Types.CREATE_MACRO]: -> showCreateMacro(undefined)
}
